import React from "react";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import { useDispatch, useSelector } from "react-redux";
import { switchView } from "../redux/activitiesSaga";

export const LineChart = () => {
  const dispatch = useDispatch();
  const table_view = useSelector((state) => state.activities.selectedFilters.table_view);
  const {
    data: { data_table },
    data
  } = useSelector((state) => state.activities.chartsData?.lineChartData?.content);
  const switchChartView = (data) => dispatch(switchView(data));

  return (
    <GoogleChart
      chartName="contact_logs_chart"
      width="1350px"
      height="400"
      isTableView={table_view}
      rows={data_table?.rows ?? []}
      columns={data_table?.cols ?? []}
      options={data?.options}
      enableEventListeners
      chartType={table_view ? "Table" : "LineChart"}
      showAdditionTooltip={false}
      switchView={switchChartView}
    />
  );
};
